import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { Admin } from './components/Admin'

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
